import { Dispatch, SetStateAction, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { ModalProps } from '../types/recommendationsModal.types';

export const CUSTOM_TRIGGER_GA_EVENT_NAME = 'trigger-ga-data';

export function useRecommendationsModalAnalyticsListeners(
  setModalProps: Dispatch<SetStateAction<ModalProps>>,
) {
  const intl = useIntl();

  useEffect(() => {
    const handleInitMaterialAddedToBag = () => {
      setModalProps((prev) => ({
        ...prev,
        isInitMaterialAddedToBag: true,
      }));
    };

    window.addEventListener(
      CUSTOM_TRIGGER_GA_EVENT_NAME,
      handleInitMaterialAddedToBag,
    );

    return () => {
      window.addEventListener(
        CUSTOM_TRIGGER_GA_EVENT_NAME,
        handleInitMaterialAddedToBag,
      );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [intl]);
}
